/**
 * Filtro responsável por formatar um endereço estruturado.
 * 
 * Recebe como argumentos o endereço a ser formatado (objeto do tipo Address) e, opcionalmente,
 * o separador de linhas que deve ser utilizado. Se nenhum separador é informado, utiliza
 * o separador HTML <BR>.
 */
angular.module("avlib").filter('avAddress', ["$filter", "countryConst", function ($filter, countryConst) {
    return function(address, lineBreak, showCoord){
    	if (address != null){
    		/*
    		 * Definindo o separado de linhas a ser utilizado:
    		 */
    		if (lineBreak == null){
    			lineBreak = "<br>";
    		}
    		/*
    		 * Utilizaremos um padrão para endereços nacionais e um padrão
    		 * diferente para endereços internacionais
    		 */
    		var formatted = "";
    		if (address.country.id == countryConst.BRAZIL){
    			/*
    			 * Primeira linha: nome da rua, número e complemento (apartamento, etc)
    			 */
    			if (address.street){
    				formatted += address.street;
    			}
    			if (address.street && (address.street_number || address.apartment)){
    				formatted += ", ";
    			}
				if (address.street_number){
					formatted += address.street_number;
				}
				if (address.apartment){
					if (address.street_number){
						formatted += " / ";
					}
					formatted += address.apartment;
				}
    			/*
    			 * Segunda linha: bairro, cidade e Estado
    			 */
				if (formatted){
					formatted += lineBreak;
				}
    			if (address.district){
    				formatted += address.district;
    			}
    			if (address.district && (address.city || address.state)){
    				formatted += " - ";
    			}
    			if (address.city){
    				formatted += address.city.name;
        			if (address.state){
        				formatted += " / ";
        			}
    			}
    			if (address.state){
    				formatted += address.state.ibge_code;
    			}
    			/*
    			 * Terceira linha: CEP
    			 */
    			if (address.zip_code){
    				formatted += lineBreak;
    				formatted += $filter('brCep')(address.zip_code);
    			}
//    			formatted += "<br>";
//    			formatted += address.country.name;
    			/*
    			 * Quarta linha: Referẽncias para acesso
    			 */
    			if (address.address_directions){
    				formatted += lineBreak;
    				formatted += "("+address.address_directions+")";
    			}
    		}else{
    			/*
    			 * Nos endereços internacionais existe apenas um campo com todas as informações consolidadas
    			 * e o nome do País:
    			 */
    			if (address.foreign_address){
    				formatted += address.foreign_address;
    				formatted += lineBreak;
    			}
    			formatted += address.country.name;
    		}
    		if (showCoord && address.latitude && address.longitude){
				formatted += lineBreak;
				formatted += lineBreak;
    			formatted += "Lat/long: "+address.latitude+", "+address.longitude;
    		}
    		return formatted;
    	}
    	return null;
    };
}]);
